import { Component, Input, Output, EventEmitter } from '@angular/core';

/**
 * SuggestedMatchCardComponent
 * Reusable card for displaying a suggested match (used in both modal and sidepanel).
 * Inputs:
 *   - match: the suggested match object
 *   - index: index of the match in the list (optional)
 *   - selected: whether this match is currently selected (optional)
 *   - someCardSelected: indicates if any card in the parent container is selected (for visual feedback)
 *   - disabled: disables the card/button (optional)
 * Outputs:
 *   - select: emits when the card is selected
 *   - toggle: emits when the selection state is toggled
 */
@Component({
  selector: 'app-suggested-match-card',
  templateUrl: './suggested-match-card.component.html',
  styleUrls: ['./suggested-match-card.component.scss']
})
export class SuggestedMatchCardComponent {
  @Input() match: any;
  @Input() index?: number;
  @Input() selected: boolean = false;
  @Input() someCardSelected: boolean = false;
  @Input() disabled: boolean = false;
  @Output() select = new EventEmitter<any>();
  @Output() toggle = new EventEmitter<any>();

  /**
   * Handle card click to toggle selection
   * @param event Mouse click event
   */
  onCardClick(event: Event) {
    // Stop event propagation to prevent it from triggering parent's clearSelection
    event.stopPropagation();
    
    if (!this.disabled) {
      // If already selected, do nothing (can only deselect by selecting another card)
      if (!this.selected) {
        this.toggle.emit({ match: this.match, index: this.index });
      }
    }
  }

  getInitials(name: string): string {
    if (!name) return '';
    const parts = name.split(' ');
    if (parts.length === 1) return parts[0][0];
    return parts[0][0] + parts[1][0];
  }

  /**
   * Returns the absolute value of the amount (makes negative values positive)
   * @param amount The amount value from the match
   */
  getAbsoluteAmount(amount: number): number {
    if (!amount) return 0;
    return Math.abs(amount);
  }

  /**
   * Returns the hex color for the supplier badge, or a default if not present
   */
  getBadgeColor(): string {
    // Try match.badgeColor, match.color, or fallback
    return (
      this.match?.badgeColor ||
      this.match?.color ||
      '#fac180' // fallback color
    );
  }
}
